module.exports = __webpack_public_path__ + "static/hero-50fe1ec6c14401b4c230e29681f0b941.jpg";